import React from 'react';

import type { Printable } from '@/features/execute-calculation-set/overmind/calculation/domain/Printable';
import type { EvaluatedResult } from '@/features/execute-calculation-set/overmind/calculation/evaluation/EvaluatedResult';

import { EvaluatedValue } from './MediumVoltageCalculation/LoadFlowSummaryCalculationResults/EvaluatedCalculationResult';

export const EvaluatedResultComponent = <T extends Printable>(props: {
  result: EvaluatedResult<T>;
  unitLabel?: boolean;
  numberOfDigits?: number;
}) => (
  <EvaluatedValue
    value={props.result.value.toString({
      withUnit: props.unitLabel,
      numberOfDigits: props.numberOfDigits
    })}
    status={props.result.status}
  />
);
